import { Locale } from './lib/types/types';

export const DEFAULT_LOCALE: Locale = 'en-US';

export const ACCEPTED_DOC_MIME_TYPES: string[] = [
    'image/png',
    'image/gif',
    'image/jpg',
    'image/jpeg',
    'image/bmp',
    'application/pdf',
];

export const MAX_DOC_UPLOAD_DOCS_ALLOWED: number = 3;
export const UPLOAD_FILE_PREFIX: string = 'file';

export const QUERY_STRING_STEP_OVERRIDE: string = 'mockStep';
export const QUERY_STRING_SUBSEGMENT_OVERRIDE: string = 'mockSubSegment';
export const QUERY_STRING_ERRORID_OVERRIDE: string = 'mockErrorId';

export const DEFAULT_MINIMUM_ORG_SEARCH_VALUE_LENGTH: number = 1;
